import { sendToGAFour } from '@tracking/services/googleAnalyticsFour';
import { sendToAlgoliaAnalytics } from '@tracking/services/algolia';
import { getCurrentEnvironment } from '@general/env';

export const routeDispatch = data => {
    const { type } = data;
    const env = getCurrentEnvironment();

    switch (type) {
        case 'login':
        case 'view':
        case 'search':
            sendToGAFour(data);
            break;

        case 'conversion':
        case 'click':
            sendToGAFour(data);
            sendToAlgoliaAnalytics(data);
            break;

        default:
            if (env !== 'production') {
                console.error('No type for tracking provided. Data not sent to analytics.');
                console.log('trackingData at error:', data);
            }
            break;
    }
};
